/**
 * fundus 模块数据
 *
 */

import { getTxtData, computedDataFundus } from '@/utils/fundusData'
import { txtData } from '@/api/index'
const fundus = {
  state: {
    fundusData: [], /// fundus页面数据
    styleImginfofundus: {}, /// fundus的图片大小数据
    fundusIndex: 0, /// 控制当前数据位置
    gobackData: [], /// 回退上一步
    nextData: [], /// 记录下一步数据,当点击上一步按钮后，goBackData pop数据，并填入此
    backFlag: false, /// 是否点击回退上一步,
    nextFlag: false// 是否点击下一步
  },
  getters: {
    getfundusMarkList (state) {
      return state.fundusData.length !== 0 ? state.fundusData[state.fundusIndex].markList : []
    },
    /// 获取当前index的数据，用于生成txt save
    getfundusdataNow (state) {
      return state.fundusData.length !== 0 ? state.fundusData[state.fundusIndex] : []
    },
    getfundusImg (state) {
      console.log(state.fundusData[state.fundusIndex].img)
      return state.fundusData[state.fundusIndex].img || ''
    },
    getbackDisabeled (state) {
      return state.gobackData.length === 0
    },
    getnextDisabeled (state) {
      return state.nextData.length === 0
    },
    getfundusjsonData (state) {
      return state.fundusData.length !== 0 ? state.fundusData[state.fundusIndex].jsonData : []
    }
  },
  mutations: {
    setbackFlag (state, payload) {
      state.backFlag = payload
    },
    setnextFlag (state, payload) {
      state.nextFlag = payload
    },
    /// 写入数据
    setfundusData (state, payload) {
      state.fundusData = payload
    },

    /// 写入jsonData
    setfundujsonData (state, payload) {
      if (state.fundusData.length !== 0) {
        state.fundusData[state.fundusIndex].jsonData=payload
      }
    },
    // 改动other的txt内容
    changeOtherText (state, payload) {
      if (payload.uuid) {
        state.fundusData[state.fundusIndex].markList.filter((item) => {
          if (item.uuid === payload.uuid) {
            item.text = `other-${payload.otherContent}`
          }
        }
        )
        state.fundusData[state.fundusIndex].drewList.filter((item) => {
          if (item.uuid === payload.uuid) {
            item.text = `other-${payload.otherContent}`
          }
        }
        )
      }
    },
    /// 处理绘图数据--获取图片大小之后再处理
    setImgStyleInfoToFundus (state, payload) {
      console.log(payload)
      const list = []
      state.styleImginfofundus = payload.list/// /如果需图片按比例调整，禁止拉伸，需要
      state.fundusData[state.fundusIndex].styleImg = payload.list
      if (state.fundusData.length !== 0) {
        /// 将drewlist处理到markList,改为页面能显示的格式
        state.fundusData[state.fundusIndex].drewList.forEach((item2, index2) => {
          const da = computedDataFundus(item2, 1, state.fundusData[state.fundusIndex].styleImg)
          list.push(da)
        })
        state.fundusData[state.fundusIndex].markList = list
      }
    },
    /// /插入框图数据
    pushFundusMarkdata (state, payload) {
      // console.log('push',payload)
      state.fundusData[state.fundusIndex].markList.push(payload)/// 插入数据
      const da = computedDataFundus(payload, 0, state.fundusData[state.fundusIndex].styleImg)
      state.fundusData[state.fundusIndex].drewList.push(da)/// 写入转换后数据
      if (!state.backFlag || state.nextFlag) { /// 未点击时，操作默认记录到backdata，点击上一步后，不记录
        /// 插入新数据时，记录上一步
        const backdata = {
          uuid: payload.uuid, /// 位置
          type: 'push',
          data: payload,
          flag: 0
        }
        state.gobackData.push(backdata)
        state.backFlag = false/// 重置标志位
        state.nextFlag = false/// 重置标志位
      }
    },
    /// 修改或删除
    spliceFundusMarkdata (state, payload) {
      if (payload.data) {
        state.fundusData[state.fundusIndex].markList.splice(payload.i, 1, payload.data)/// 修改数据
        const da = computedDataFundus(payload.data, 0, state.fundusData[state.fundusIndex].styleImg)
        state.fundusData[state.fundusIndex].drewList.splice(payload.i, 1, da)
        if (!state.backFlag || state.nextFlag) { /// 一次改变动作只记录一次
          /// 记录上一步
          const length = state.gobackData.length - 1
          const backdata = {
            uuid: payload.data.uuid, /// 位置
            type: 'change',
            data: payload.data,
            flag: 0
          }
          console.log(backdata)
          const olduuid = state.gobackData[length].uuid
          const newuuid = backdata.uuid
          if (olduuid !== newuuid || (olduuid === newuuid && state.gobackData[length].type === 'push')) {
            state.gobackData.push(backdata)
          } else {
            // state.gobackData[length] = backdata
          }

          console.log(state.gobackData)
          state.backFlag = false/// 重置标志位
          state.nextFlag = false/// 重置标志位
        }
      } else {
        const data = state.fundusData[state.fundusIndex].drewList[payload.i]
        state.fundusData[state.fundusIndex].markList.splice(payload.i, 1)
        state.fundusData[state.fundusIndex].drewList.splice(payload.i, 1)
        if (!state.backFlag || state.nextFlag) {
          /// 记录上一步
          const backdata = {
            uuid: payload.uuid, /// 位置
            type: 'delete',
            data: data,
            flag: 0
          }
          state.gobackData.push(backdata)
          state.backFlag = false/// 重置标志位
          state.nextFlag = false/// 重置标志位
        }
      }
    }

  },
  actions: {
    /// 切换上一步下一步函数
    goBackOrNext (ctx, params) {
      if (params === 'back') { // 上一步
        /// 弹出上一步数据
        const back = ctx.state.gobackData.pop()
        /// 将数据重新写入(如果是点击重写的数据，不算做上一步记录值)
        if (back) {
          const index = ctx.state.fundusData[ctx.state.fundusIndex].markList.findIndex((item) => item.uuid === back.uuid)
          if (index !== -1) {
            let pay = {}
            if (back.type === 'push') {
              pay = {
                i: index,
                uuid: back.uuid
              }
            } else {
              pay = {
                i: index,
                uuid: back.uuid,
                data: back.data
              }
            }
            ctx.commit('spliceFundusMarkdata', pay)
          } else {
            ctx.commit('pushFundusMarkdata', back.data)
          }
        }
        /// 并将弹出数据写入下一步
        ctx.state.nextData.push(back)
      } else if (params === 'next') { // 下一步
        /// 弹出上一步数据
        const next = ctx.state.nextData.pop()
        /// 将数据重新写入(如果是点击重写的数据，不算做上一步记录值)

        if (next) {
          const index = ctx.state.fundusData[ctx.state.fundusIndex].markList.findIndex((item) => item.uuid === next.uuid)
          if (index !== -1) {
            let pay = {}
            if (next.type === 'push') {
              pay = {
                i: index,
                uuid: next.uuid
              }
            } else {
              pay = {
                i: index,
                uuid: next.uuid,
                data: next.data
              }
            }
            ctx.commit('spliceFundusMarkdata', pay)
          } else {
            ctx.commit('pushFundusMarkdata', next.data)
          }
        }
        /// 并将弹出数据不再记录
      }

      console.log(ctx.state.gobackData)
      console.log(ctx.state.nextData)
    },
    async getFundusData (ctx, params) {
      const list = []
      /// 测试，只针对fileData
      const fileData = '2 0.304243 0.216374 0.185191 0.108772  康醫師  0\n1 0.591764 0.265497 0.103993 0.051462  康醫師  0\n3 0.905158 0.770760 0.183028 0.052632  康醫師  0\n4 0.520466 0.118129 0.415973 0.107602  黃醫師  0\n5 0.810732 0.264327 0.355241 0.102924  黃醫師  0\n7 0.510732 0.364327 0.355241 0.302924  Dr.Lin  0\n6 0.710732 0.564327 0.355241 0.102924  黃醫師  0'
      const da = getTxtData(fileData)
      const jsonData = await txtData('/static/txtfile/points.json')
      
      console.log(da)
      const obj = {
        styleImg: {},
        drewList:da.list, /// 已有的标注数据--算法的格式
        markList:[], /// 页面的显示格式
        userInfor: {},
        pngFileName: '100010_231133_1234.jpg', /// 图片名称,与txt名称对应
        // img:'@/assets/images/6.jpg'，
        // brushImg:'',////笔刷图片的路径
        /// brushJson:'',///笔刷坐标json文件路径
        jsonData: jsonData
      }
      list.push(obj)
      ctx.commit('setfundusData', list)
      // console.log(ctx.state.fundusData)
    }
  }
}
export default fundus
